export const GET_PAYMENT_METHODS = `query GetPaymentMethods{
    active: paymentMethods(status:ACTIVE first:50) {
        edges{
            node {
                ...paymentMethodNode
            }
        }
    }
    requiresAction: paymentMethods(status:REQUIRES_ACTION first:50) {
        edges{
            node {
                ...paymentMethodNode
            }
        }
    }
    processing: paymentMethods(status:PROCESSING first:50) {
        edges{
            node {
                ...paymentMethodNode
            }
        }
    }
}

fragment paymentMethodNode on PaymentMethod {
    id
    provider
    status
    user {
        email
    }
    expirationDate
    last4
    setupToken
    metadata
    type
}`;
